core.constant('videoConsultationMeedyTranslationPL', {
  "T": {
    "MEEDY": {
      "SYSTEM": {
        "ERROR": {
          "ERROR_RECEIVING_STREAMING_DETAILS" : "Wystąpił błąd podczas próby połączenia.",
          "INVALID_STREAMING_STATUS" : "Niepoprawny status połączenia",
          "ACCESS_DENIED" : "Brak dostępu"

        },
        "MESSAGE": {
        }
      },
      "UI": {
        "APPLICATION": {
          "CALLING" : "Ktoś dzwoni!",
          "YOU_HAVE_A_CALL" : "Masz telefon!",
          "CHAT_WITH" : "Przeprowadzasz rozmowę z {{ firstName }} {{ lastName }}."
        },
        "TABBAR": {
        },
        "TITLE": {
          "VIDEO_CONSULTATION": {
            "DEMO_VIDEO_CONSULTATION" : "Demo wideo konsultacji"
          }
        },
        "BUTTON": {
          "START" : "Start",
          "STOP" : "Stop",
          "CONNECT" : "Połącz",
          "TRY_AGAIN" : "Spróbuj ponownie",
          "FINISHED" : "Rozmowa została zakończona",
          "CLOSE" : "Zamknij"
        }
      },
      "MODULE": {
        "VIDEO_CONSULTATION": {
          "REPLAY_RECORDING" : "Odtwórz nagrania",
          "SOMEBODY_IS_CALLING" : "Dzwoni do Ciebie {{ firstName }} {{ lastName }}, z wizyty o godzinie {{ startDate | date:'HH:mm' }}.",
          "DO_YOU_WANT_TO_ANSWER" : "Czy chcesz odebrać?",
          "DO_YOU_WANT_TO_FINISH_CHAT" : "Czy chcesz zakończyć rozmowę?",
          "ANSWER" : "Odbierz",
          "REFUSE" : "Odrzuć",
          "FINISHED_CHAT" : "Czat zakończono",
          "NOT_ANSWERED_FROM" : "Nie odebrałeś rozmowy od ",
          "PATIENT_NETWORK_ISSUE" : "Wystąpił problem z połączeniem internetowym u Ciebie lub u Twojego Pacjenta. Pacjent powinien niedługo się do Ciebie odezwać.",
          "ATTACHMENTS_LIST_TITLE" : "Dokumenty pacjenta",
          "FINISHED_CONSULTATION" : "Konsultacja zakończona"
        }
      }
    }
  }
});
